import { portalApi } from '@/axios'

export default class UserSettingService {
  /**
   * Get the user settings by key
   *
   * @param {string} key
   *
   * @return {Promise}
   */
  static getUserSettings (key, defaultValue = '') {
    let request = portalApi.get(`user-settings/${key}`, { enableHandler: false }).then(response => {
      return response.data
    }).catch(error => {
      return error.response.status === 404 ? Promise.resolve() : Promise.reject(error)
    })

    return request.then(response => {
      return response ? JSON.parse(response.data.value) : defaultValue
    })
  }

  /**
   * Save user settings by key
   *
   * @param {string} key
   * @param {Object} value
   *
   * @return {Promise}
   */
  static saveUserSettings (key, value) {
    return portalApi.put(`user-settings/${key}`, { value: JSON.stringify(value) }).then(response => response.data)
  }
}
